/**
 * Created by emanuele on 31/01/2017.
 */
import React, {Component} from 'react';

class PrintButton extends Component {
    constructor(props) {
        super(props);
        this.onStampaClick = this.onStampaClick.bind(this);
    }

    onStampaClick(ev){
        window.print();
    }

    render(){
        let title = this.props.title ? this.props.title : 'Stampa'
        return <a href="#" onClick={(ev) => (this.onStampaClick(ev))}>
            <div className="ui left floated small primary labeled icon button">
                <i className="print icon"></i> {title}
            </div>
        </a>
    }
}

export default PrintButton;


/** WEBPACK FOOTER **
 ** ./src/components/PrintButton.jsx
 **/